import React from 'react';
import { Route, Routes } from 'react-router-dom';

type Props = { children?: React.ReactNode };

export function TenantRoute({ children }: Props) {
  return (
    <Routes>
      <Route
        path={'/(admin|profile|sign-out|sign-in|docs|auth|organization)/*'}
      />
      <Route path="/*" element={<>{children}</>} />
    </Routes>
  );
}
